import { FunctionComponent } from 'preact';

import { IconButtonProps } from '../IconButton/IconButton';
import { usePlayerState } from '../../hooks/usePlayerState';

import { PlayButton } from './PlayButton';
import { PauseButton } from './PauseButton';

export const TogglePlayButton: FunctionComponent<IconButtonProps> = (props) => {
  const state = usePlayerState();

  return state === 'playing' ? (
    <PauseButton {...props} />
  ) : (
    <PlayButton {...props} />
  );
};
